var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector28(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08083 0C8.23167 0 9.16417 0.9325 9.16417 2.08333C9.16417 3.23417 8.23167 4.16667 7.08083 4.16667C5.93 4.16667 4.9975 3.23417 4.9975 2.08333C4.9975 0.9325 5.93 0 7.08083 0ZM10.8308 7.08333C10.8308 5.93417 9.89667 5 8.7475 5H5.41417C4.265 5 3.33083 5.93417 3.33083 7.08333V7.5H10.8308V7.08333ZM19.2908 7.23417C18.8617 6.84333 18.3025 6.64083 17.7258 6.66917C17.145 6.69583 16.61 6.9475 16.2308 7.365L13.28 10.4792C13.3067 10.6542 13.3342 10.8292 13.3342 11.0108C13.3342 12.7467 12.0383 14.2408 10.32 14.4858L6.78583 14.9908L6.55 13.3417L10.0842 12.8367C10.9875 12.7075 11.6675 11.9225 11.6675 11.0108C11.6675 9.99417 10.84 9.16667 9.82333 9.16667H2.5C1.12167 9.16667 0 10.2883 0 11.6667V17.5C0 18.8783 1.12167 20 2.5 20H10.5533L19.4483 10.2875C20.2383 9.4025 20.1667 8.0325 19.2908 7.23417Z",
    fill: "#F26639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector28);
export default __webpack_public_path__ + "static/media/Vector (28).d0eabfa4442d079c7ba9fbdebffdfe66.svg";
export { ForwardRef as ReactComponent };